import { Button, useTheme } from "@mui/material";
import { Plus } from "lucide-react";
import type { FC } from "react";

type Props = {
	label: string;
	onClick: () => void;
};

export const PinInlineAction: FC<Props> = ({ label, onClick }) => {
	const theme = useTheme();

	return (
		<Button
			variant="inlineAction"
			startIcon={<Plus size={theme.iconSize.sm} />}
			onClick={onClick}
			sx={{
				borderTop: theme.colors.border.solid(theme.palette.surface.border),
			}}
		>
			{label}
		</Button>
	);
};
